const localStorage =
  typeof window !== 'undefined' ?
    window.localStorage
  : {
      getItem: () => null,
      setItem: () => null,
      removeItem: () => null,
      clear: () => null,
    };

export default localStorage;
